// start:ng42.barrel
export * from '@app/dashboard/dashboard/dashboard.component';
// end:ng42.barrel
